var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTehnovse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 160 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: url(#radial-gradient);\n      }\n\n      .st1 {\n        fill: url(#radial-gradient1);\n      }\n\n      .st2 {\n        fill: url(#radial-gradient3);\n      }\n\n      .st3 {\n        fill: url(#radial-gradient2);\n      }\n\n      .st4 {\n        fill: #f5f5f5;\n      }\n\n      .st5 {\n        fill: #221e1f;\n      }\n    "), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient",
    cx: -337.1,
    cy: 332,
    fx: -337.1,
    fy: 332,
    r: 0.2,
    gradientTransform: "translate(-24436 24873.1) rotate(90) scale(73.7 -73.7)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e9364b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e22f2f"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient1",
    cx: -336.5,
    cy: 328.3,
    fx: -336.5,
    fy: 328.3,
    r: 0.2,
    gradientTransform: "translate(-78845.1 20390.1) rotate(90) scale(60.5 -240.5)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient2",
    cx: -336.5,
    cy: 328.3,
    fx: -336.5,
    fy: 328.3,
    r: 0.2,
    gradientTransform: "translate(-78845.1 20390.1) rotate(90) scale(60.5 -240.5)",
    xlinkHref: "#radial-gradient"
  }), /*#__PURE__*/React.createElement("radialGradient", {
    id: "radial-gradient3",
    cx: -336.5,
    cy: 328.3,
    fx: -336.5,
    fy: 328.3,
    r: 0.2,
    gradientTransform: "translate(-78845.1 20390.1) rotate(90) scale(60.5 -240.5)",
    xlinkHref: "#radial-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.2,22.4c0-4.4,3.6-8,8-8h15.1c4.4,0,8,3.6,8,8v15.1c0,4.4-3.6,8-8,8h-15.1c-4.4,0-8-3.6-8-8v-15.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M17.1,36.1v-12.1c0-.7.3-1.3.8-1.8s1.1-.8,1.8-.8h10.7c.5,0,.9.4.9.9s-.4.9-.9.9h-10.7c-.2,0-.4,0-.6.3s-.3.4-.3.6v12.1c0,.2,0,.4.3.6.2.2.4.3.6.3h12.1c.2,0,.4,0,.6-.3.2-.2.3-.4.3-.6v-7.2c0-.5.4-.9.9-.9.5,0,.9.4.9.9v7.2c0,.7-.3,1.3-.8,1.8-.5.5-1.1.8-1.8.8h-12.1c-.7,0-1.3-.3-1.8-.8-.5-.5-.8-1.1-.8-1.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M33.8,22.5c.3-.3.9-.3,1.2,0,.3.3.3.9,0,1.2l-8.6,8.6c-.3.3-.9.3-1.2,0l-2.6-2.6c-.3-.3-.3-.9,0-1.2.3-.3.9-.3,1.2,0l2,2,8-8Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M144.5,38.2c-1.2,0-2.2-.2-3.1-.7-.9-.5-1.5-1.2-2-2.1-.5-.9-.7-1.9-.7-3.2s.2-2.2.7-3.1c.5-.9,1.1-1.6,1.9-2.1.8-.5,1.8-.8,3-.8s1.5.1,2.1.4c.7.2,1.2.6,1.7,1.1.5.5.9,1.1,1.2,1.8.3.7.4,1.6.4,2.6v.9h-9.7v-2h6.7c0-.5,0-.9-.3-1.2-.2-.4-.5-.6-.8-.8-.4-.2-.8-.3-1.2-.3s-.9.1-1.3.3c-.4.2-.7.5-.9.9-.2.4-.3.8-.3,1.2v1.9c0,.6.1,1.1.3,1.5.2.4.5.7.9,1,.4.2.9.3,1.4.3s.7,0,1-.1c.3-.1.5-.3.8-.5.2-.2.4-.4.5-.7l3,.2c-.2.7-.5,1.3-.9,1.9-.5.5-1.1.9-1.8,1.2-.7.3-1.6.4-2.5.4ZM142,24.8c-.4,0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1c.3-.3.7-.4,1.1-.4s.8.1,1.1.4c.3.3.5.7.5,1.1s-.2.8-.5,1.1c-.3.3-.7.5-1.1.5ZM146.6,24.8c-.4,0-.8-.2-1.1-.5-.3-.3-.5-.7-.5-1.1s.2-.8.5-1.1c.3-.3.7-.4,1.1-.4s.8.1,1.1.4c.3.3.5.7.5,1.1s-.2.8-.5,1.1c-.3.3-.7.5-1.1.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M132,38.2c-1.2,0-2.2-.2-3-.8-.8-.5-1.5-1.2-2-2.1-.5-.9-.7-1.9-.7-3.1s.2-2.2.7-3.1c.5-.9,1.1-1.6,2-2.1.8-.5,1.9-.8,3-.8s1.9.2,2.6.5c.8.4,1.4.9,1.8,1.5.4.7.7,1.4.7,2.3h-3c0-.6-.3-1-.7-1.4-.4-.4-.8-.5-1.4-.5s-.9.1-1.3.4c-.4.3-.7.7-.9,1.2-.2.5-.3,1.1-.3,1.9s.1,1.4.3,1.9c.2.5.5.9.9,1.2.4.3.8.4,1.3.4s.7,0,1-.2c.3-.1.5-.4.7-.7.2-.3.3-.6.4-1h3c0,.9-.3,1.7-.7,2.3-.4.7-1,1.2-1.8,1.6-.8.4-1.6.6-2.7.6Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M112.9,37.9v-15.4h6.2c1.1,0,2.1.2,2.8.5.8.3,1.3.8,1.7,1.4.4.6.6,1.3.6,2s-.1,1.1-.4,1.6c-.2.5-.6.8-1,1.1-.4.3-.9.5-1.4.6v.2c.6,0,1.1.2,1.6.5.5.3.9.7,1.3,1.3.3.5.5,1.2.5,2s-.2,1.5-.6,2.2c-.4.6-1,1.1-1.8,1.5-.8.4-1.8.6-2.9.6h-6.6ZM116.2,35.3h2.6c.9,0,1.6-.2,2-.5.4-.4.6-.8.6-1.4s-.1-.8-.3-1.1c-.2-.3-.5-.6-.9-.8-.4-.2-.8-.3-1.3-.3h-2.7v4.1ZM116.2,29h2.4c.4,0,.8,0,1.2-.2.4-.2.6-.4.8-.7.2-.3.3-.6.3-1s-.2-1-.6-1.3c-.4-.3-.9-.5-1.7-.5h-2.5v3.8Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M105.1,38.2c-1.2,0-2.2-.2-3-.7-.8-.5-1.5-1.2-2-2.1-.5-.9-.7-1.9-.7-3.1s.2-2.2.7-3.1c.5-.9,1.1-1.6,2-2.1.9-.5,1.9-.8,3-.8s2.2.3,3,.8c.9.5,1.5,1.2,2,2.1.5.9.7,1.9.7,3.1s-.2,2.2-.7,3.1c-.5.9-1.1,1.6-2,2.1-.8.5-1.9.7-3,.7ZM105.1,35.7c.5,0,1-.2,1.3-.5.4-.3.6-.7.8-1.2.2-.5.3-1.1.3-1.8s0-1.3-.3-1.8c-.2-.5-.4-.9-.8-1.2s-.8-.5-1.3-.5-1,.2-1.4.5c-.4.3-.6.7-.8,1.2-.2.5-.3,1.1-.3,1.8s0,1.3.3,1.8c.2.5.5.9.8,1.2.4.3.8.5,1.4.5Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M95.4,30.9v2.5h-6v-2.5h6ZM90.5,26.4v11.5h-3.1v-11.5h3.1ZM97.4,26.4v11.5h-3v-11.5h3Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M77.9,26.4l2.1,4,2.2-4h3.3l-3.3,5.8,3.4,5.8h-3.3l-2.3-4-2.2,4h-3.3l3.4-5.8-3.3-5.8h3.3Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M68.1,38.2c-1.2,0-2.2-.2-3.1-.7-.9-.5-1.5-1.2-2-2.1-.5-.9-.7-1.9-.7-3.2s.2-2.2.7-3.1c.5-.9,1.1-1.6,1.9-2.1.8-.5,1.8-.8,3-.8s1.5.1,2.1.4c.7.2,1.2.6,1.7,1.1.5.5.9,1.1,1.2,1.8.3.7.4,1.6.4,2.6v.9h-9.7v-2h6.7c0-.5,0-.9-.3-1.2-.2-.4-.5-.6-.8-.8-.4-.2-.8-.3-1.2-.3s-.9.1-1.3.3c-.4.2-.7.5-.9.9-.2.4-.3.8-.3,1.2v1.9c0,.6.1,1.1.3,1.5.2.4.5.7.9,1,.4.2.9.3,1.4.3s.7,0,1-.1c.3-.1.5-.3.8-.5.2-.2.4-.4.5-.7l3,.2c-.2.7-.5,1.3-.9,1.9-.5.5-1.1.9-1.8,1.2-.7.3-1.6.4-2.5.4Z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M49.9,25.3v-2.7h12.6v2.7h-4.7v12.7h-3.2v-12.7h-4.7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTehnovse);
export default __webpack_public_path__ + "static/media/tehnovse.34aa0ae01322c2dadcec9ebb50ab7799.svg";
export { ForwardRef as ReactComponent };